import React from 'react';

import Icon from 'components/shared/Icon';
import Group from 'components/shared/Icon/icons/Group';
import i18n from 'i18n';

import { ContentLink } from './ContentLink';
import s from './index.module.css';
import { ITableOfContentsProps } from './types';

const TableOfContents = ({ links, activeLinkId }: ITableOfContentsProps) => {
  return (
    <div className={s.items}>
      <div className={s.item}>
        <div className={s.head}>
          <Icon component={Group} className={s.icon} />
          <div className={s.title}>{i18n.t('proposal_content.table_of_contents')}</div>
        </div>
      </div>
      {links.map((link) => {
        return <ContentLink key={link.id} link={link} activeLinkId={activeLinkId} />;
      })}
    </div>
  );
};
export default TableOfContents;
